var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEditBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 1.9853C20.0667 2.25462 20.0667 2.69129 19.8 2.96062L18.3761 4.39907L15.6454 1.64045L17.0693 0.201995C17.3359 -0.0673319 17.7682 -0.0673316 18.0348 0.201995L19.8 1.9853Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4107 5.37439L14.6799 2.61577L5.37766 12.013C5.30272 12.0887 5.24626 12.181 5.21274 12.2826L4.11422 15.6118C4.02527 15.8814 4.27914 16.1378 4.54599 16.048L7.84155 14.9382C7.9421 14.9044 8.03346 14.8473 8.1084 14.7716L17.4107 5.37439Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.931C0 19.0737 0.916946 20 2.04806 20H17.0671C18.1982 20 19.1152 19.0737 19.1152 17.931V9.65517C19.1152 9.27429 18.8095 8.96552 18.4325 8.96552C18.0555 8.96552 17.7498 9.27429 17.7498 9.65517V17.931C17.7498 18.3119 17.4442 18.6207 17.0671 18.6207H2.04806C1.67102 18.6207 1.36537 18.3119 1.36537 17.931V2.75862C1.36537 2.37774 1.67102 2.06897 2.04806 2.06897H10.923C11.3 2.06897 11.6056 1.7602 11.6056 1.37931C11.6056 0.998425 11.3 0.689655 10.923 0.689655H2.04806C0.916946 0.689655 0 1.61596 0 2.75862V17.931Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditBox);
export default __webpack_public_path__ + "static/media/ico-edit-box.bcae04fc4b195118146e5430e75adcd7.svg";
export { ForwardRef as ReactComponent };